<!--模板导入 页面-->
<template>
  <div class="gray-back">
    <van-tabs v-model="active" class="tab-nav" sticky @click="onStatusChange">
      <van-tab title="正常"></van-tab>
      <van-tab title="隐藏"></van-tab>
    </van-tabs>
    <div class="box yundongyuan-box">


      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div class="kaojicenter-list-box">
            <div class="kaojicenter-lists flex-between" :key="index" v-for="(item, index) in list"
                 @click="action(item, index)">
              <div class="kaojicenter-rights">
                <div class="title">{{ item.name }}</div>
                <div class="desc flex-start">
                  <van-tag round v-if="item.cert_status==1" type="success">已认证</van-tag>
                  <van-tag round v-else-if="item.cert_status==3">认证失败</van-tag>
                  <van-tag round v-else-if="item.cardtype==1 && item.cert_status==2" type="warning">未认证</van-tag>
                  <van-tag round plain v-else-if="item.cardtype!=1 && item.cert_status==2">无需认证</van-tag> &nbsp;
                  {{ item.num }}
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

      <van-action-sheet v-model="actionShow" :actions="actions" @select="onActionSelect"/>

      <div class="savebtn">
        <van-uploader
            accept=".xls,.xlsx"
            :after-read="readFile"
        >
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round>导入模板
          </van-button>
        </van-uploader>

      </div>
      <van-popup :close-on-click-overlay="false" v-model="showLoading">
        <div class="circle-div">
          <van-circle :stroke-width="60" :color="{
                                '0%': '#ffad19',
                                '100%': '#fec835',
                              }" v-model="progress" :rate="progress" :speed="100" :text="progress+'%'"/>
          <van-button
              style="width: 3rem; margin-top: 10px"
              size="normal" round>上传中
          </van-button>
        </div>
        <div>
        </div>

      </van-popup>

      <van-dialog v-model="showError" title="批量导入错误信息">
        <van-cell-group>
          <van-cell :title="item" :key="index" v-for="(item,index) in errorMsg"/>
        </van-cell-group>
      </van-dialog>
    </div>
  </div>
</template>
<style scoped>

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.kaojicenter-list-box {
  padding-top: 0.2rem;
  /*background: rgba(248,248,248,1);*/
}

.goods-line {
  height: 55px;
}

.goods-bottom-line {
  width: 100%;
  position: fixed;
  height: 60px;
  bottom: 0;
  background: linear-gradient(180deg, hsla(255, 0%, 100%, 0), #fff);
}

.goods-create-btn {
  position: fixed;
  bottom: 10px;
  width: 100%;
  height: 44px;
  font-size: 16px;
  text-align: center;
}

.goods-create-btn button {
  width: 3.2rem;
}

.goods-create-btn img {
  width: 60px;
  height: 60px;
}

.goods-header {
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  margin-bottom: 0.01rem;
  background: #fff;
}

.van-tabs {
  /*width: 85% !important;*/
}

.screen-btn {
  line-height: 44px;
  height: 44px;
}

.screen-btn img {
  width: 45%;
  padding-left: 15px;
  vertical-align: middle;
  border-left: 1px solid #D5D5D5;
}

.sidebar {
  padding-top: 15px;
}

.search-box img {
  width: 60px;
  height: 60px;
}


.select-btn {
  position: fixed;
  bottom: 0;
  width: 90%;
  margin: 0 auto;
  padding: 0px 15px 30px;
}

.btn-reset {
  padding-bottom: 10px;
}

.btn-reset >>> .van-button {
  background: #ddd;
}

.selected {
  color: #444;
}


.kaojicenter-lists {
  padding: 0.2rem;
  border-radius: 10px;
  background: #fff;
  margin: 0 0.2rem 0.2rem;
}

.kaojicenter-lefts {
  position: relative;
}


.kaojicenter-lefts .img {
  border-radius: 10px;
  width: 1rem;
  height: 1rem;
}

.kaojicenter-rights {
  width: calc(100% - 1.2rem);
  position: relative;
  height: 1rem;
}

.kaojicenter-rights .title {
  font-size: 15px;
  font-weight: bold;
}

.kaojicenter-rights .desc {
  font-size: 12px;
  padding-top: 10px;
  color: #999;
}

.yundongyuan-box >>> .van-popup {
  background: none;
}

.circle-div {
  text-align: center;
}

.circle-div >>> .van-circle__text {
  color: #fff !important;
}
</style>

<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import IdCardPicker from "../../../components/picker/IdCardPicker.vue";

import {
  Cell,
  CellGroup,
  Toast,
  Dialog,
  Icon,
  PullRefresh,
  List,
  Tag,
  Button,
  Progress,
  DropdownMenu,
  DropdownItem,
  DatetimePicker
} from 'vant';
import XLSX from "xlsx";

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(Progress).use(DropdownMenu).use(DropdownItem).use(DatetimePicker);
export default {
  name: 'YundongyuanListShare',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    IdCardPicker
  },
  data: function () {
    return {
      validator,
      id: 0,
      active: 0,
      showDate: false,
      showError: false,
      showLoading: false,
      actionShow: false,
      addShow: false,
      list: [],
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照', '其他身份证明'],
      actions: [
        {name: '隐藏'},
        {name: '认证'},
      ],
      params: {
        user_id: 0,
        pageNo: 1,
        pageSize: 10,
        keywords: '',
        cate_id: 0,
        is_show: 1
      },
      formData: {
        user_id: 0,
        name: '',
        num: '',
        huzhao: '',
        cardtype: 1,
        birthday: '',
        sex: 1,
        numTypeName: '身份证',
        jianhuname: '',
        jianhunum: '',
        jianhuphone: '',
      },
      saveLoading: false,
      isLoading: false,
      loading: false,
      finished: false, 


      listData: [],
      errorMsg: [], // 错误列表
      index: 0,
      progress: 0,
    }
  },
  mounted() {
    document.title = "运动员管理"
    let user_id = this.params.user_id = this.$route.query.user_id
    if (!user_id) {
      Toast.fail('请输入正确的链接')
      return
    }
    this.getList();
  },
  computed: {
    showBirthday() {
      return this.formData.cardtype != 1;
    },
    showSex() {
      return this.formData.cardtype != 1;
    },
    showJianhu() {
      return this.formData.cardtype != 1 || (item => {
        if (this.formData.num.trim().length == 18) {
          var year = Number(this.formData.num.trim().substr(6, 4));
          var curYear = new Date().getFullYear();
          if (curYear - year < 18) {
            return true
          }
        }
      })();
    }
  },
  filters: {
    cert(value) {
      switch (value) {
        case 1 :
          return '#ff0000'
          break;
        case 2 :
          return '#FF9966'
          break;
        case 3 :
          return '#FFFF33'
          break;
      }
    }
  },
  destroyed() {
  },
  methods: {
    getList() {
      let that = this;
      that.$api.get('/api/yundongyuan/yundongyuanShareList', that.params, (res) => {
        that.loading = false;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }

        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.pageNo += 1;
      })
    },


    // 上拉加载
    // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
    // 可以延迟异步的时间
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log('this.params.pageNo')

      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.getList()
        }, 500);
      }

    },

    readFile(evt) {
      console.log('------readFile------', evt)
      var that = this;
      that.errorMsg = []
      that.index = 0

      let files = {0: evt.file}

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const wsname = workbook.SheetNames[0];//取第一张表
          var list = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容

          if (that.startNum) {
            list = list.splice(that.startNum, list.length)
          }

          that.listData = list
          // let listData = list.filter(row => {
          //   return row.hasOwnProperty("__EMPTY");
          // })
          console.log('onGetData', list)

          // todo 增加进度条显示 并上传数据

          that.formatData()

        } catch (e) {
          console.log(e)
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },

    formatData() {
      let that = this
      that.showLoading = true
      // that.listData.map((row) => {
        that.addRow()
        // return ;
      // })
    },

    addRow() {
      // return ;
      let that = this
      let row  =  that.listData[that.index];
      console.log(row);
      that.formData.name = row['姓名']
      switch (row['证件类型（身份证，护照，其他）']) {
        case '身份证':
          that.formData.cardtype = 1
          that.formData.num = row['证件号']
          break;
        case '护照':
          that.formData.cardtype = 2
          that.formData.huzhao = row['证件号']
          that.formData.birthday = row['生日（1997-01-01）'] ? row['生日（1997-01-01）'] : ''
          that.formData.sex = row['性别（男，女）'] ? (row['性别（男，女）'] === '男' ? 1 : 2) : ''
          break;
        case '其他':
          that.formData.cardtype = 3
          that.formData.huzhao = row['证件号']
          that.formData.birthday = row['生日（1997-01-01）'] ? row['生日（1997-01-01）'] : ''
          that.formData.sex = row['性别（男，女）'] ? (row['性别（男，女）'] === '男' ? 1 : 2) : ''
          break;
      }
      that.formData.jianhuname = row['监护人姓名'] ? row['监护人姓名'] : ''
      that.formData.jianhuphone = row['监护人手机'] ? row['监护人手机'] : ''
      that.formData.jianhunum = row['监护人证件号'] ? row['监护人证件号'] : ''
      that.formData.user_id = that.params.user_id


      console.log(that.formData)
      // return ;
      that.yundongyuanAdd()
    },

    yundongyuanAdd() {
      let that = this
      that.$api.post('/api/yundongyuan/addAll', that.formData, (res) => {
        // that.onRefresh();
        that.formData = {
          name: '',
          num: '',
          huzhao: '',
          cardtype: 1,
          birthday: '',
          sex: 1,
          numTypeName: '身份证',
          jianhuname: '',
          jianhunum: '',
          jianhuphone: '',
        }; 
        that.getProgress()
        that.addRow();
      }, (res) => {
        if (res.code === 600) {
          that.errorMsg.push(that.formData.name +' '+res.msg)
        } 
        that.getProgress()
        that.addRow();
      })
    },

    getProgress() {
      let that = this
      that.index ++; 

      let index = that.index,
          list = that.listData

      console.log(that.errorMsg, index, list.length)

      that.progress = parseInt((index / list.length) * 100).toFixed(0)
      if (index >= list.length) {
        that.showLoading = false
        that.onRefresh()

        if (that.errorMsg.length > 0) {
          // 唤起弹框
          that.showError = true

        } else {
          Toast.success('批量导入成功')
        }
      }
    },

    action(item, index) {
      return
      this.actionShow = true;
      this.params.id = item.id;
      this.params.name = item.name;
      this.actions = [];
      if (item.is_show == 1) {
        this.actions.push({name: '隐藏'});
      } else {
        this.actions.push({name: '显示'});
      }
      if (item.cert_status == 2) {
        this.actions.push({name: '认证'});
      } else {
      }

    },
    onActionSelect(action, index) {
//                console.log(action); return ;
      let that = this;
      switch (index) {
        case 0 :
          if (action.name == '隐藏') {
            Dialog.confirm({
              title: '确认',
              message: '是否隐藏该运动员?',
            })
                .then(() => {
                  // on confirm
                  that.$api.post('/api/yundongyuan/hide', {
                    id: that.params.id
                  }, (res) => {
                    that.onRefresh();
                  }, (res) => {
                    Toast.fail(res.msg);
                  })

                })
                .catch(() => {
                  // on cancel
                });
          } else {
            that.$api.post('/api/yundongyuan/show', {
              id: that.params.id
            }, (res) => {
              that.onRefresh();
            }, (res) => {
              Toast.fail(res.msg);
            })
          }

          this.actionShow = false;
          break;

        case 1 :
          //认证
          // on confirm
          that.$api.post('/api/yundongyuan/cert', {
            id: that.params.id
          }, (res) => {
            that.onRefresh();
          }, (res) => {
            Toast.fail(res.msg);
          })
          break;

        case 2 :


          break;

      }
      this.actionShow = false;
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },

    onDateConfirm(date) {
      console.log('onDateConfirm', date);
      this.showDate = false;
      this.formData.birthday = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    submit() {

    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.cardtype = index + 1;
      this.showNumTypePicker = false;
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onFamilyIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.jianhuname = data.name;
      this.formData.jianhunum = data.cardNum;
    },
    onIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.name = data.name;
      this.formData.num = data.cardNum;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;
      that.$api.post('/api/yundongyuan/add', that.formData, (res) => {
        that.saveLoading = false;
        that.addShow = false;
        that.onRefresh();
        that.formData = {
          name: '',
          num: '',
          huzhao: '',
          cardtype: 1,
          birthday: '',
          sex: 1,
          numTypeName: '身份证',
          jianhuname: '',
          jianhunum: '',
          jianhuphone: '',
        };
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },


    // 更改状态
    onStatusChange(index) {

      let that = this;
      that.params.is_show = index + 1;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.is_show = 0;
      that.getList()
    },


  }
}
</script>



// WEBPACK FOOTER //
// YundongyuanListShare.vue?e80142a0